import { SearchContainer, Input, Icon } from './styles';
import { VscSearch } from 'react-icons/vsc';

interface SearchBarProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  className?: string;
  background?: string;
  width?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder, className, background, width }) => {
  return (
    <SearchContainer className={className} background={ background || 'none' } width={width || 'inherit'}>
      <Icon>
        <VscSearch />
      </Icon>
      <Input
        id="search-input"
        type="text" 
        value={value} 
        onChange={onChange} 
        placeholder={placeholder} 
      />
    </SearchContainer>
  );
};

export default SearchBar;
